import { Button, Modal, DatePicker, Form, Row, Col, DatePickerProps, Tooltip, Flex } from "antd";
import { useEffect } from "react";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import * as Icon from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import CadastroFeriado from "./modals/cadastrar";
import { formatData } from "../../util/dataAuxiliar";
import { setBuscaFeriado, setEntityFeriado, setModalCadastrarFeriado, setModalDeletarFeriado } from "../../redux/slices/feriado/feriadoSlice";
import { FeriadoModel } from "../../models/feriado/feriadoModel";
import Search from "antd/es/input/Search";
import { buscarFeriado, deletarFeriado } from "../../services/feriadoService";
import dayjs from "dayjs";
import { BuscarFeriadoModel } from "../../models/feriado/chamadas/buscarFeriadoModel";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import { ButtonComponent } from "../../components/button/cadastrar";
import TableComponent from "../../components/table/tableComponent";
import MensagemModal from "../../components/modal/mensagem";

dayjs.locale("pt-br");

const Feriado = () => {
  //estados globais
  const feriadoState = useAppSelector((state) => state.feriado);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  const editar = Object.values(feriadoState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("FERIADOS"));
    dispatch(
      buscarFeriado({
        pesquisar: feriadoState.busca.pesquisar,
        dataInicio: feriadoState.busca.dataInicio,
        dataFim: feriadoState.busca.dataFim,
      })
    );
    form.setFieldsValue({ dataInicio: dayjs(feriadoState.busca.dataInicio), dataFim: dayjs(feriadoState.busca.dataFim) });
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityFeriado({}));
    dispatch(setModalCadastrarFeriado(true));
  };

  const goEditar = (value: any) => {
    dispatch(setEntityFeriado(value));
    dispatch(setModalCadastrarFeriado(true));
  };

  const closeModalCadastro = () => {
    dispatch(setModalCadastrarFeriado(false));
  };

  const goDeletar = (value: any) => {
    dispatch(setEntityFeriado(value));
    dispatch(setModalDeletarFeriado(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarFeriado(false));
  };

  const onSearch = (value: string) => {
    let args: BuscarFeriadoModel = { ...feriadoState.busca, pesquisar: value };

    dispatch(setBuscaFeriado(value));
    dispatch(buscarFeriado(args));
  };

  const onChangeDateInicio = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let args: BuscarFeriadoModel = { ...feriadoState.busca, dataInicio: dayjs(value).toDate() };

    dispatch(setBuscaFeriado(args));
    dispatch(buscarFeriado(args));
  };

  const onChangeDateFim = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let args: BuscarFeriadoModel = { ...feriadoState.busca, dataFim: dayjs(value).toDate() };

    dispatch(setBuscaFeriado(args));
    dispatch(buscarFeriado(args));
  };

  const atualizar = () => {
    dispatch(buscarFeriado(feriadoState.busca));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<FeriadoModel> = [
    {
      title: "FERIADO",
      dataIndex: "denominacao",
      sorter: (a, b) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "DATA",
      dataIndex: "data",
      align: "center",
      width: 120,
      render: (_, record) => {
        return <>{record.tipo === 0 ? formatData(record.data.substring(0, 10)).substring(0, 5) : dayjs(record.data).format("DD/MM/YYYY")}</>;
      },
    },
    {
      title: "TIPO",
      dataIndex: "tipo",
      align: "center",
      filters: [
        {
          text: "Fixo",
          value: "0" as any,
        },
        {
          text: "Variável",
          value: "1" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.tipo.toString().includes(value),
      sorter: (a, b) => a.tipo - b.tipo,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => (record.tipo === 0 ? "Fixo" : "Variável"),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar">
                <Search allowClear placeholder="Feriado" onSearch={onSearch} className="searchInput" style={{ width: 300 }} enterButton />
              </Form.Item>
              <Form.Item label="Data início" name="dataInicio">
                <DatePicker placeholder="" allowClear={false} onChange={onChangeDateInicio} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label="Data fim" name="dataFim">
                <DatePicker placeholder="" allowClear={false} onChange={onChangeDateFim} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label=" ">
                <Tooltip title="Atualizar">
                  <Button icon={<Icon.RedoOutlined />} className="buttonPrimary" style={{ minHeight: 32 }} onClick={atualizar} />
                </Tooltip>
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={feriadoState.list} columns={columns} loading={feriadoState.loading} />
      <Modal title={editar ? "EDITAR FERIADO" : "NOVO FERIADO"} centered width={1150} open={feriadoState.modalCadastrar} onCancel={closeModalCadastro} footer={null} destroyOnHidden>
        <CadastroFeriado />
      </Modal>
      <Modal title={"REMOVER FERIADO"} centered width={350} open={feriadoState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal text="Deseja remover o feriado?" action={deletarFeriado({ value: feriadoState.entity.id, busca: feriadoState.busca })} close={setModalDeletarFeriado(false)} />
      </Modal>
    </Flex>
  );
};

export default Feriado;
